<template>
  <tree-select
    v-model="ids"
    :value-format="valueFormat"
    style="display: inline-block"
    class="tree-select"
    :options="departmentTreeFull"
    :normalizer="normalizer"
    :placeholder="placeholder"
    :multiple="multiple"
    :flat="multiple"
    :auto-select-descendants="multiple"
    append-to-body
    no-options-text="暂无数据"
    :z-index="zIndex"
  />
</template>

<script>
// 组件
import TreeSelect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

// 工具函数
import { transListToTree } from '@/utils/company'
import { mapState } from 'vuex'

// 引入api接口
import { getDepartmentListApi, getSubCompanyListApi } from '@/api/company'
import { getEmployeeSuperviseApi } from '@/api/user'

export default {
  // 部门机构树形选择框
  name: 'DepartmentTreeSelect',

  components: {
    TreeSelect
  },

  props: {
    // 使用场景
    scenes: {
      validator: function(value) {
        return (
          ['supervision', 'department', 'deptAndCompany'].indexOf(value) !== -1
        )
      },
      default: 'department'
    },

    deptIds: {
      type: [Array, String, undefined],
      default: undefined
    },

    companyIds: {
      type: [Array, String, undefined],
      default: undefined
    },

    placeholder: {
      type: String,
      default: '请选择'
    },

    zIndex: {
      type: [Number, String],
      default: 998
    },

    //
    valueFormat: {
      type: String,
      default: 'id'
    },

    multiple: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      // ids: [],
      departmentTreeFull: []
    }
  },

  computed: {
    ...mapState('company', ['companyId']),

    ids: {
      get() {
        // if (Array.isArray(this.deptIds)) {
        //   return this.deptIds.filter(value => value)
        // } else if (this.multiple) {
        //   return this.deptIds ? [this.deptIds] : []
        // } else {
        //   return this.deptIds
        // }

        const companyIdsTemp = []
        if (Array.isArray(this.companyIds)) {
          companyIdsTemp.push(...this.companyIds)
        } else if (this.companyIds) {
          companyIdsTemp.push(this.companyIds)
        }

        const deptIdsTemp = []
        if (Array.isArray(this.deptIds)) {
          deptIdsTemp.push(...this.deptIds)
        } else if (this.deptIds) {
          deptIdsTemp.push(this.deptIds)
        }

        let temp = []
        if (this.organizationScope === 'all') {
          temp = [
            ...companyIdsTemp.map(id => `sub${id}`),
            ...deptIdsTemp.map(id => `dept${id}`)
          ]
        } else if (this.organizationScope === 'company') {
          temp = companyIdsTemp
        } else if (this.organizationScope === 'dept') {
          temp = deptIdsTemp
        }

        if (!this.multiple) {
          return temp[0] || undefined
        } else {
          return temp
        }
      },
      set(val) {
        // this.$emit('change', val)
        if (!Array.isArray(val)) {
          val = val ? [val] : []
        }

        let deptIdsTemp = []
        let companyIdsTemp = []
        switch (this.organizationScope) {
          case 'all':
            val.forEach(id => {
              if (id.indexOf('dept') > -1) {
                deptIdsTemp.push(id.replace('dept', ''))
              }
              if (id.indexOf('sub') > -1) {
                companyIdsTemp.push(id.replace('sub', ''))
              }
            })
            break
          case 'company':
            companyIdsTemp = val
            break
          case 'dept':
            deptIdsTemp = val
            break
        }

        if (!this.multiple) {
          deptIdsTemp = deptIdsTemp[0] || undefined
          companyIdsTemp = companyIdsTemp[0] || undefined
        }
        this.$emit('update:deptIds', deptIdsTemp)
        this.$emit('update:companyIds', companyIdsTemp)
      }
    },

    // 组织架构包含（子公司和部门：all，子公司：company，部门：dept）
    organizationScope() {
      const temp = {
        supervision: 'all',
        department: 'dept',
        deptAndCompany: 'all'
      }
      return temp[this.scenes]
    }
  },

  created() {
    this.getDepartmentTreeData()
  },

  methods: {
    // 获取部门树形数据，并添加公司改造
    getDepartmentTreeData() {
      const apiObj = {
        supervision: () =>
          getEmployeeSuperviseApi().then(res => {
            const deptList = (res?.data?.superviseDepts || []).map(value => {
              return {
                id: value.deptId,
                name: value.name,
                parentId: value.parentId || 0,
                type: 'department',
                nodeKey: `${this.companyId}-${value.deptId}`
              }
            })

            const companyList = (res?.data?.superviseCompanies || [])
              .map(value => {
                if (value.companyId === this.companyId) return undefined

                return {
                  id: value.companyId,
                  nodeKey: `${value.companyId}`,
                  type: 'company',
                  name: value.companyName,
                  parentId: value.parentId || 0
                }
              })
              .filter(value => value)

            return [
              ...transListToTree(deptList, 'id'),
              ...transListToTree(companyList, 'id')
            ]
          }),

        department: () =>
          // 这里的type：1， 表示只要公司的部门列表；不传的情况下会返回一级子公司列表和部门列表
          getDepartmentListApi({ type: 1 }).then(res => {
            const temp = (res.data || []).map(value => {
              return {
                id: value.deptId,
                name: value.deptInfo?.name || '',
                parentId: value.parentInfo?.parentId || 0,
                type: 'department',
                nodeKey: `${value.companyId}-${value.deptId}`
              }
            })

            return transListToTree(temp, 'id')
          }),

        deptAndCompany: () =>
          Promise.all([
            getSubCompanyListApi(),
            getDepartmentListApi({ type: 1 })
          ]).then(result => {
            const companyList = (result[0]?.data || []).map(value => {
              return {
                id: value.companyId,
                nodeKey: `${value.companyId}`,
                type: 'company',
                name: value.companyName,
                parentId: value?.parentInfo?.parentId || 0
              }
            })

            const deptList = (result[1]?.data || []).map(value => {
              return {
                id: value.deptId,
                name: value.deptInfo?.name || '',
                parentId: value.parentInfo?.parentId || 0,
                type: 'department',
                nodeKey: `${value.companyId}-${value.deptId}`
              }
            })

            return [...transListToTree(deptList, 'id'), ...companyList]
          })
      }

      apiObj[this.scenes]()
        .then(res => {
          this.departmentTreeFull = res
        })
        .catch(err => {
          if (err) {
            this.$message.error(err.message)
          } else {
            console.log('log err', err)
          }
        })
    },

    // 添加和编辑员工，选择部门的转换函数
    normalizer(node) {
      if (node.children && !node.children.length) {
        delete node.children
      }

      let idTemp = ''
      if (this.organizationScope === 'all') {
        idTemp = node.type === 'company' ? `sub${node.id}` : `dept${node.id}`
      } else {
        idTemp = node.id
      }

      return {
        id: idTemp,
        label: node.name,
        children: node.children
      }
    },

    // 通过当前的deptId获取对应label
    /**
     * 通过id获取对应的label
     * @param ids {String | Number | Array} 选中的id
     * @param type {String} department表示匹配部门id，company表示匹配子公司id
     * @returns {*[]} 返回label的数组
     */
    getLabelListByDeptIds(ids = this.ids, type = 'department') {
      const tempIds = Array.isArray(ids) ? ids : [ids]

      const loop = (tree, result) => {
        tree.forEach(dept => {
          if (tempIds.includes(dept.id) || tempIds.includes(String(dept.id))) {
            if (dept.type === type) {
              result.push(dept.name)
            }
          }

          if (dept.children && dept.children.length) {
            loop(dept.children, result)
          }
        })
      }

      const result = []
      loop(this.departmentTreeFull, result)

      return result
    }
  }
}
</script>
